import { RefObject, useEffect, useState, useMemo } from 'react'

/* v8 ignore start */
export const useIxOnScreen = (ref: RefObject<any>) => {
    const [isIntersecting, setIsIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIsIntersecting(entry.isIntersecting)
    ), [])

    useEffect(() => {
        if (!ref.current) { return }

        observer.observe(ref.current)

        return () => { observer.disconnect() }
    })

    return isIntersecting
}
/* v8 ignore end */
